import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
	<App className="app" />,
	document.getElementById('obsess-web-store-container'),
);
